/* fitplacehn — theme.js
   Vanilla JS. transform/opacity animations live in CSS; JS only toggles state.
   Respects that no library is loaded (no jQuery, no framework). */
(function () {
  'use strict';

  /* ---------- Hero slider ---------- */
  function initHero(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hero-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hero-dot]'));
    if (slides.length < 2) return;
    var index = 0;
    var timer;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.hidden = n !== index; });
      dots.forEach(function (d, n) { d.setAttribute('aria-current', n === index ? 'true' : 'false'); });
    }
    function next() { show(index + 1); }
    function prev() { show(index - 1); }
    function start() { stop(); timer = setInterval(next, 6000); }
    function stop() { if (timer) clearInterval(timer); }

    var nextBtn = root.querySelector('[data-hero-next]');
    var prevBtn = root.querySelector('[data-hero-prev]');
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); start(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); start(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { show(parseInt(d.dataset.heroDot, 10)); start(); });
    });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) start();
  }
  document.querySelectorAll('[data-hero]').forEach(initHero);

  /* ---------- Mobile nav ---------- */
  var burger = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('.header__nav');
  if (burger && nav) {
    var setNav = function (open) {
      burger.setAttribute('aria-expanded', String(open));
      nav.classList.toggle('header__nav--open', open);
    };
    burger.addEventListener('click', function (e) {
      e.stopPropagation();
      setNav(burger.getAttribute('aria-expanded') !== 'true');
    });
    /* Close when a link is chosen or when tapping outside the menu */
    nav.addEventListener('click', function (e) {
      if (e.target.closest('a')) setNav(false);
    });
    document.addEventListener('click', function (e) {
      if (nav.classList.contains('header__nav--open') &&
          !nav.contains(e.target) && !burger.contains(e.target)) {
        setNav(false);
      }
    });
  }

  /* ---------- Submenús del menú móvil (desplegable de categorías) ---------- */
  document.querySelectorAll('[data-submenu-toggle]').forEach(function (toggle) {
    var sub = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!sub) return;
    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(open));
      sub.hidden = !open;
    });
  });

  /* ---------- Best-sellers tabs ---------- */
  document.querySelectorAll('[data-tabs]').forEach(function (tabs) {
    var grid = tabs.parentElement.querySelector('[data-tab-grid]');
    if (!grid) return;
    var items = Array.prototype.slice.call(grid.querySelectorAll('[data-tab-item]'));
    tabs.querySelectorAll('[data-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.querySelectorAll('[data-tab]').forEach(function (t) { t.setAttribute('aria-selected', 'false'); });
        tab.setAttribute('aria-selected', 'true');
        var key = tab.dataset.tab;
        items.forEach(function (it) {
          it.style.display = (key === 'all' || it.dataset.tabItem === key) ? '' : 'none';
        });
      });
    });
  });

  /* ---------- Cart drawer ---------- */
  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-overlay]');
  var lastFocus;
  function openCart() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    overlay.hidden = false;
    requestAnimationFrame(function () {
      overlay.setAttribute('data-open', 'true');
      drawer.setAttribute('data-open', 'true');
      drawer.setAttribute('aria-hidden', 'false');
    });
    var close = drawer.querySelector('[data-cart-close]');
    if (close) close.focus();
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!drawer) return;
    overlay.removeAttribute('data-open');
    drawer.removeAttribute('data-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(function () { overlay.hidden = true; }, 400);
    if (lastFocus) lastFocus.focus();
  }
  document.querySelectorAll('[data-cart-open]').forEach(function (b) { b.addEventListener('click', openCart); });
  document.querySelectorAll('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closeCart); });
  if (overlay) overlay.addEventListener('click', closeCart);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.getAttribute('data-open') === 'true') closeCart();
  });

  /* ---------- Wishlist (own, localStorage-backed; brand-native, no app dependency) ----------
     Persists across the store via our heart buttons on cards + PDP, drives the header
     count badge, and renders the saved-items grid on /pages/wishlist. Client-side only. */
  var WL_KEY = 'fitplace_wishlist_v1';
  function wlRead() {
    try { var v = JSON.parse(localStorage.getItem(WL_KEY)); return Array.isArray(v) ? v : []; }
    catch (e) { return []; }
  }
  function wlWrite(list) {
    try { localStorage.setItem(WL_KEY, JSON.stringify(list)); } catch (e) {}
  }
  function wlItemFromBtn(btn) {
    var d = btn.dataset;
    return {
      id: d.wlId || '', handle: d.wlHandle || '', title: d.wlTitle || '',
      url: d.wlUrl || '', image: d.wlImage || '', cat: d.wlCat || '', variant: d.wlVariant || ''
    };
  }
  function wlHas(list, id) { return list.some(function (i) { return String(i.id) === String(id); }); }

  function wlRefreshButtons() {
    var list = wlRead();
    document.querySelectorAll('[data-wishlist]').forEach(function (btn) {
      var on = wlHas(list, btn.dataset.wlId);
      btn.setAttribute('aria-pressed', String(on));
      var label = btn.querySelector('[data-wl-label]');
      if (label) label.textContent = on ? STR_WL.remove : STR_WL.add;
    });
  }
  function wlRefreshCount() {
    var n = wlRead().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = String(n);
      el.hidden = n === 0;
    });
  }
  var STR_WL = { add: 'Agregar a lista de deseos', remove: 'Quitar de lista de deseos' };

  function wlToggle(btn) {
    var list = wlRead();
    var id = btn.dataset.wlId;
    if (wlHas(list, id)) {
      list = list.filter(function (i) { return String(i.id) !== String(id); });
    } else {
      list.push(wlItemFromBtn(btn));
    }
    wlWrite(list);
    wlRefreshButtons();
    wlRefreshCount();
    wlRenderPage();
  }

  /* Event delegation so dynamically rendered hearts (wishlist page) also work */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-wishlist]');
    if (btn) { e.preventDefault(); wlToggle(btn); }
  });

  /* Drop legacy items with no way to reach a product (old seed/placeholder saves) */
  (function wlMigrate() {
    var list = wlRead();
    var clean = list.filter(function (i) { return i && (i.handle || i.url); });
    if (clean.length !== list.length) wlWrite(clean);
  })();

  /* Render saved items on /pages/wishlist */
  var wlGrid = document.querySelector('[data-wishlist-grid]');
  var wlEmpty = document.querySelector('[data-wishlist-empty]');
  function wlItemUrl(i) { return i.url || (i.handle ? '/products/' + i.handle : ''); }

  function wlRenderPage() {
    if (!wlGrid) return;
    var list = wlRead();
    if (list.length === 0) {
      wlGrid.hidden = true;
      wlGrid.innerHTML = '';
      if (wlEmpty) wlEmpty.hidden = false;
      return;
    }
    if (wlEmpty) wlEmpty.hidden = true;
    wlGrid.hidden = false;
    wlGrid.innerHTML = list.map(function (i) {
      var url = wlItemUrl(i);
      var media = i.image
        ? '<img src="' + escapeHtml(i.image) + '" alt="' + escapeHtml(i.title) + '" width="600" height="600" loading="lazy">'
        : '';
      if (url) media = '<a class="product-card__media-link" href="' + escapeHtml(url) + '" aria-label="' + escapeHtml(i.title) + '">' + media + '</a>';
      var cat = i.cat ? '<span class="product-card__cat">' + escapeHtml(i.cat) + '</span>' : '';
      var title = url
        ? '<a href="' + escapeHtml(url) + '">' + escapeHtml(i.title) + '</a>'
        : escapeHtml(i.title);
      var actions =
        (i.variant
          ? '<button type="button" class="btn btn--sm btn--block" data-add-to-cart data-variant-id="' + escapeHtml(i.variant) + '">' + WL_PLUS + '<span>Agregar al carrito</span></button>'
          : '') +
        (url ? '<a class="btn btn--outline btn--sm btn--block" href="' + escapeHtml(url) + '">Ver producto</a>' : '');
      return '<article class="product-card wl-card">' +
        '<div class="product-card__media">' +
          '<button type="button" class="product-card__wish" aria-pressed="true" aria-label="' + escapeHtml(STR_WL.remove) + '" ' +
            'data-wishlist data-wl-id="' + escapeHtml(i.id) + '" data-wl-handle="' + escapeHtml(i.handle || '') + '" ' +
            'data-wl-title="' + escapeHtml(i.title) + '" data-wl-url="' + escapeHtml(i.url || '') + '" ' +
            'data-wl-cat="' + escapeHtml(i.cat || '') + '" data-wl-variant="' + escapeHtml(i.variant || '') + '" ' +
            'data-wl-image="' + escapeHtml(i.image || '') + '">' + WL_HEART + '</button>' +
          media +
        '</div>' +
        '<div class="product-card__body">' + cat +
          '<h3 class="product-card__title">' + title + '</h3>' +
          '<div class="wl-card__actions">' + actions + '</div>' +
        '</div>' +
      '</article>';
    }).join('');
    /* Bind add-to-cart on freshly rendered cards */
    wlGrid.querySelectorAll('[data-add-to-cart]').forEach(function (b) {
      b.addEventListener('click', function () {
        var id = b.getAttribute('data-variant-id');
        if (!id) return;
        addToCart({ id: id, quantity: 1 }).catch(function (err) {
          if (err && err.status === 422) markUnavailable(b);
        });
      });
    });
    wlHydrate(list);
  }

  /* Self-heal: fill missing variant/url/image from the live product JSON (by handle) */
  var wlHydrated = false;
  function wlHydrate(list) {
    if (wlHydrated) return;
    var need = list.filter(function (i) { return i.handle && (!i.variant || !i.url || !i.image); });
    if (need.length === 0) return;
    wlHydrated = true;
    Promise.all(need.map(function (i) {
      return fetch('/products/' + i.handle + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return;
          i.url = i.url || p.url || ('/products/' + p.handle);
          if (!i.image) i.image = p.featured_image || (p.images && p.images[0]) || '';
          if (!i.cat) i.cat = p.type || '';
          if (!i.variant) {
            var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
            if (v) i.variant = String(v.id);
          }
        }).catch(function () {});
    })).then(function () { wlWrite(list); wlRenderPage(); });
  }
  var WL_HEART = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8Z"/></svg>';
  var WL_PLUS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';

  wlRefreshButtons();
  wlRefreshCount();
  wlRenderPage();

  /* ---------- Search panel (drops from header; focus-trapped to Escape) ---------- */
  (function () {
    var panel = document.querySelector('[data-search-panel]');
    if (!panel) return;
    var openers = document.querySelectorAll('[data-search-open]');
    var closer = panel.querySelector('[data-search-close]');
    var input = panel.querySelector('[data-search-input]');
    function open() {
      panel.hidden = false;
      requestAnimationFrame(function () { panel.setAttribute('data-open', 'true'); });
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      if (input) input.focus();
    }
    function close() {
      panel.removeAttribute('data-open');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      setTimeout(function () { panel.hidden = true; }, 240);
    }
    function toggle() { (panel.getAttribute('data-open') === 'true') ? close() : open(); }
    openers.forEach(function (b) { b.addEventListener('click', toggle); });
    if (closer) closer.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.getAttribute('data-open') === 'true') { close(); }
    });
  })();

  /* ---------- Cart page: quantity steppers (native <form> update on change) ---------- */
  document.querySelectorAll('[data-cart-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('[data-qty-input]');
    if (!input) return;
    var form = input.closest('[data-cart-page]');
    var minus = wrap.querySelector('[data-qty-minus]');
    var plus = wrap.querySelector('[data-qty-plus]');
    function step(dir) {
      var next = Math.max(0, (parseInt(input.value, 10) || 0) + dir);
      var max = parseInt(input.getAttribute('max'), 10);
      if (!isNaN(max)) next = Math.min(next, max);
      if (next === (parseInt(input.value, 10) || 0)) return;
      input.value = next;
      if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
    }
    if (minus) minus.addEventListener('click', function () { step(-1); });
    if (plus) plus.addEventListener('click', function () { step(1); });
  });

  /* ---------- Collection sort (auto-submit on change; no-JS falls back to submit button) ---------- */
  document.querySelectorAll('[data-sort]').forEach(function (select) {
    select.addEventListener('change', function () {
      var form = select.closest('[data-sort-form]');
      if (form) form.submit();
    });
  });

  /* ---------- Money formatting (Shopify canonical, uses shop.money_format) ---------- */
  var moneyFormat = (drawer && drawer.getAttribute('data-money-format')) || 'L. {{amount}}';
  function formatMoney(cents) {
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var frac = parts[1] ? decimal + parts[1] : '';
      return whole + frac;
    }
    var match = String(moneyFormat).match(placeholder);
    var token = match ? match[1] : 'amount';
    var value;
    switch (token) {
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      default: value = fmt(cents, 2);
    }
    return String(moneyFormat).replace(placeholder, value);
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ---------- Cart (real Ajax on Shopify's native cart API) ---------- */
  var cartBody = drawer && drawer.querySelector('[data-cart-body]');
  var cartFoot = drawer && drawer.querySelector('[data-cart-foot]');
  var cartEmpty = drawer && drawer.querySelector('[data-cart-empty]');
  var cartSubtotal = drawer && drawer.querySelector('[data-cart-subtotal]');

  function setCounts(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = String(n); });
  }

  function renderCart(cart) {
    if (!drawer) return;
    setCounts(cart.item_count);
    var existing = cartBody.querySelector('.cart-lines');
    if (existing) existing.remove();

    if (cart.item_count === 0) {
      if (cartEmpty) cartEmpty.hidden = false;
      if (cartFoot) cartFoot.hidden = true;
      return;
    }
    if (cartEmpty) cartEmpty.hidden = true;
    if (cartFoot) cartFoot.hidden = false;
    if (cartSubtotal) cartSubtotal.textContent = formatMoney(cart.total_price);

    var html = '<ul class="cart-lines">';
    cart.items.forEach(function (item) {
      var img = item.image || (item.featured_image && item.featured_image.url) || '';
      html += '<li class="cart-line" data-line-key="' + escapeHtml(item.key) + '">' +
        '<a class="cart-line__media" href="' + escapeHtml(item.url) + '" data-cart-close>' +
          (img ? '<img src="' + escapeHtml(img) + '" alt="" width="64" height="64" loading="lazy">' : '') +
        '</a>' +
        '<div class="cart-line__info">' +
          '<span class="cart-line__title"><a href="' + escapeHtml(item.url) + '" data-cart-close>' + escapeHtml(item.product_title) + '</a></span>' +
          (item.variant_title ? '<span class="cart-line__variant">' + escapeHtml(item.variant_title) + '</span>' : '') +
          '<div class="cart-line__foot">' +
            '<div class="cart-line__qty">' +
              '<button type="button" data-line-minus aria-label="Disminuir cantidad">&#8722;</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-line-plus aria-label="Aumentar cantidad">+</button>' +
            '</div>' +
            '<button type="button" class="cart-line__remove" data-line-remove>Quitar</button>' +
          '</div>' +
          '<p class="cart-line__note" data-line-note hidden></p>' +
        '</div>' +
        '<span class="cart-line__price">' + formatMoney(item.final_line_price) + '</span>' +
      '</li>';
    });
    html += '</ul>';
    cartBody.insertAdjacentHTML('afterbegin', html);
    bindLineEvents();
    checkCartStock(cart);
  }

  /* Inventario del carrito.
     /cart.js no trae disponibilidad, asi que la pedimos por producto y marcamos
     la linea agotada aqui mismo — el cliente lo ve en el carrito y no hasta el
     momento de pagar. La pagina /cart hace la misma validacion del lado servidor. */
  var STR_CART = {
    soldout: 'Agotado — quítalo para continuar',
    max: 'No hay más unidades disponibles de este producto.'
  };

  function lineNote(key, text) {
    var line = cartBody && cartBody.querySelector('.cart-line[data-line-key="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]');
    if (!line) return;
    var note = line.querySelector('[data-line-note]');
    if (!note) return;
    note.textContent = text;
    note.hidden = false;
    line.classList.add('cart-line--alerta');
  }

  function setCartAlert(blocked) {
    var alert = drawer && drawer.querySelector('[data-cart-alert]');
    if (alert) alert.hidden = !blocked;
  }

  function checkCartStock(cart) {
    setCartAlert(false);
    if (!cartBody || !cart.items || cart.items.length === 0) return;
    var handles = [];
    cart.items.forEach(function (i) {
      if (i.handle && handles.indexOf(i.handle) === -1) handles.push(i.handle);
    });
    if (handles.length === 0) return;
    Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var byHandle = {};
      handles.forEach(function (h, n) { byHandle[h] = products[n]; });
      var blocked = false;
      cart.items.forEach(function (item) {
        var p = byHandle[item.handle];
        if (!p) return;
        var v = (p.variants || []).filter(function (x) { return String(x.id) === String(item.variant_id); })[0];
        if (v && v.available === false) {
          blocked = true;
          lineNote(item.key, STR_CART.soldout);
        }
      });
      setCartAlert(blocked);
    });
  }

  function bindLineEvents() {
    cartBody.querySelectorAll('.cart-line').forEach(function (line) {
      var key = line.getAttribute('data-line-key');
      var qty = parseInt(line.querySelector('.cart-line__qty span').textContent, 10) || 1;
      var minus = line.querySelector('[data-line-minus]');
      var plus = line.querySelector('[data-line-plus]');
      var remove = line.querySelector('[data-line-remove]');
      if (minus) minus.addEventListener('click', function () { changeLine(key, qty - 1); });
      if (plus) plus.addEventListener('click', function () { changeLine(key, qty + 1, qty + 1); });
      if (remove) remove.addEventListener('click', function () { changeLine(key, 0); });
    });
    line_reset();
  }
  function line_reset() { /* re-close handlers for freshly rendered [data-cart-close] links */
    cartBody.querySelectorAll('[data-cart-close]').forEach(function (b) {
      b.addEventListener('click', closeCart);
    });
  }

  function changeLine(key, quantity, requested) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      renderCart(cart);
      /* Shopify recorta la cantidad en silencio cuando ya no hay stock: lo decimos. */
      if (requested) {
        var item = (cart.items || []).filter(function (i) { return i.key === key; })[0];
        if (item && item.quantity < requested) lineNote(key, STR_CART.max);
      }
    }).catch(function () {});
  }

  function refreshCart() {
    if (!drawer) return Promise.resolve();
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  function addToCart(payload) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    }).then(function () { return refreshCart(); }).then(openCart);
  }

  /* Shopify devuelve 422 cuando la variante ya no tiene stock (política "deny").
     Pasa con páginas abiertas desde antes y con la lista de deseos, que guarda
     el variant id en localStorage sin saber el inventario actual. */
  function markUnavailable(btn) {
    btn.disabled = true;
    var icon = btn.querySelector('svg');
    if (icon) icon.remove();
    var label = btn.querySelector('span') || btn;
    label.textContent = 'Agotado';
  }

  /* Product-card "Agregar" buttons — real add when a variant id is present */
  document.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-variant-id');
      if (!id) { openCart(); return; } // seed/placeholder card, no real product
      addToCart({ id: id, quantity: 1 }).catch(function (err) {
        if (err && err.status === 422) markUnavailable(btn);
      });
    });
  });

  /* Sync cart state on load (keeps count + drawer correct after reloads) */
  refreshCart();

  /* ---------- PDP: gallery, variant picker, quantity, accordion, add-to-cart ---------- */
  function showMedia(gallery, mediaId) {
    gallery.querySelectorAll('[data-main-img]').forEach(function (img) {
      img.hidden = img.getAttribute('data-media-id') !== mediaId;
    });
    gallery.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.setAttribute('aria-current', t.getAttribute('data-media-id') === mediaId ? 'true' : 'false');
    });
  }
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    gallery.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () { showMedia(gallery, thumb.getAttribute('data-media-id')); });
    });
  });

  /* Quantity steppers (PDP) — topados al inventario disponible */
  function qtyNoteEl(input) {
    var form = input.closest('form');
    return form ? form.querySelector('[data-qty-note]') : null;
  }
  function showQtyNote(input, max) {
    var note = qtyNoteEl(input);
    if (!note) return;
    note.textContent = max === 1
      ? 'Solo queda 1 unidad en existencia.'
      : 'Solo quedan ' + max + ' unidades en existencia.';
    note.hidden = false;
  }
  function hideQtyNote(input) {
    var note = qtyNoteEl(input);
    if (note) note.hidden = true;
  }
  document.querySelectorAll('[data-qty-input]').forEach(function (input) {
    var wrap = input.closest('.pdp__qty');
    if (!wrap) return;
    var minus = wrap.querySelector('[data-qty-minus]');
    var plus = wrap.querySelector('[data-qty-plus]');
    function step(dir) {
      var max = parseInt(input.getAttribute('data-qty-max'), 10);
      var next = Math.max(1, (parseInt(input.value, 10) || 1) + dir);
      if (!isNaN(max)) {
        if (next >= max) { next = Math.max(1, max); showQtyNote(input, max); }
        else { hideQtyNote(input); }
      }
      input.value = next;
    }
    if (minus) minus.addEventListener('click', function () { step(-1); });
    if (plus) plus.addEventListener('click', function () { step(1); });
    input.addEventListener('change', function () { step(0); });
  });

  /* Accordion (animates opacity/transform only; height snaps) */
  document.querySelectorAll('[data-accordion]').forEach(function (acc) {
    acc.querySelectorAll('[data-acc-trigger]').forEach(function (trig) {
      trig.addEventListener('click', function () {
        var expanded = trig.getAttribute('aria-expanded') === 'true';
        trig.setAttribute('aria-expanded', String(!expanded));
        var panel = document.getElementById(trig.getAttribute('aria-controls'));
        if (panel) panel.hidden = expanded;
      });
    });
  });

  /* Variant picker + PDP add-to-cart */
  var section = document.querySelector('[data-product-section]');
  if (section) {
    var jsonEl = section.querySelector('[data-variant-json]');
    var variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
    var invEl = section.querySelector('[data-inventory-json]');
    var inventory = {};
    if (invEl) { try { inventory = JSON.parse(invEl.textContent); } catch (e) { inventory = {}; } }
    var idInput = section.querySelector('[data-variant-id]');
    var picker = section.querySelector('[data-variant-picker]');
    var priceEl = section.querySelector('[data-price]');
    var stockEl = section.querySelector('[data-stock-badge]');
    var stockText = section.querySelector('[data-stock-text]');
    var stockIconOk = section.querySelector('[data-stock-icon-ok]');
    var stockIconLow = section.querySelector('[data-stock-icon-low]');
    var stockIconOut = section.querySelector('[data-stock-icon-out]');
    var qtyInput = section.querySelector('[data-qty-input]');
    var addBtn = section.querySelector('[data-add-submit]');
    var addText = section.querySelector('[data-add-text]');
    var addError = section.querySelector('[data-add-error]');
    var gallery = section.querySelector('[data-gallery]');
    var LOW_STOCK = 5;
    var STR = { add: 'Agregar al carrito', soldout: 'Agotado', unavailable: 'No disponible', tbd: 'Precio TBD', instock: 'En existencia', adding: 'Agregando...', added: '¡Agregado!',
                errStock: 'Se agotó mientras veías la página. Ya no está disponible.',
                err: 'No pudimos agregarlo al carrito. Intenta de nuevo.' };

    function setAddError(msg) {
      if (!addError) return;
      if (!msg) { addError.hidden = true; addError.textContent = ''; return; }
      addError.textContent = msg;
      addError.hidden = false;
    }

    /* Un sabor sin existencia se marca en el selector, no al intentar pagarlo. */
    function updateSwatchStates() {
      var current = selectedOptions();
      var groups = section.querySelectorAll('.pdp__option');
      Array.prototype.forEach.call(groups, function (fs, idx) {
        fs.querySelectorAll('[data-swatch]').forEach(function (label) {
          var input = label.querySelector('input[data-option-input]');
          if (!input) return;
          var test = current.slice();
          test[idx] = input.value;
          var available = variants.some(function (v) {
            return v.available && v.options.every(function (o, i) {
              return test[i] == null || o === test[i];
            });
          });
          label.classList.toggle('is-out', !available);
          var sr = label.querySelector('[data-swatch-out]');
          if (sr) sr.hidden = available;
        });
      });
    }

    /* Tope de cantidad = unidades que quedan, cuando Shopify lleva el conteo. */
    function applyInventory(v) {
      var inv = v ? inventory[v.id] : null;
      var max = (inv && inv.t) ? inv.q : null;
      if (qtyInput) {
        if (max !== null && max > 0) {
          qtyInput.setAttribute('max', max);
          qtyInput.setAttribute('data-qty-max', max);
          if ((parseInt(qtyInput.value, 10) || 1) > max) qtyInput.value = max;
        } else {
          qtyInput.removeAttribute('max');
          qtyInput.removeAttribute('data-qty-max');
          qtyInput.value = 1;
        }
        hideQtyNote(qtyInput);
      }
      return max;
    }

    function setStock(v, max) {
      if (!stockEl) return;
      var out = !v || !v.available;
      var low = !out && max !== null && max > 0 && max <= LOW_STOCK;
      stockEl.classList.toggle('pdp__stock--out', out);
      stockEl.classList.toggle('pdp__stock--low', low);
      if (stockIconOk) stockIconOk.hidden = out || low;
      if (stockIconLow) stockIconLow.hidden = !low;
      if (stockIconOut) stockIconOut.hidden = !out;
      if (stockText) {
        stockText.textContent = out
          ? STR.soldout
          : (low ? (max === 1 ? 'Solo queda 1 unidad' : 'Solo quedan ' + max + ' unidades') : STR.instock);
      }
    }

    function selectedOptions() {
      var opts = [];
      section.querySelectorAll('.pdp__option').forEach(function (fs) {
        var checked = fs.querySelector('input[data-option-input]:checked');
        opts.push(checked ? checked.value : null);
        var lbl = fs.querySelector('[data-option-selected]');
        if (lbl && checked) lbl.textContent = checked.value;
      });
      return opts;
    }
    function matchVariant(opts) {
      return variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      })[0];
    }
    function updateVariant() {
      setAddError('');
      updateSwatchStates();
      var v = matchVariant(selectedOptions());
      if (!v) {
        if (idInput) idInput.value = '';
        if (addBtn) addBtn.disabled = true;
        if (addText) addText.textContent = STR.unavailable;
        setStock(null, null);
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) {
        if (v.price > 0) { priceEl.textContent = formatMoney(v.price); priceEl.className = 'pdp__price-now'; }
        else { priceEl.textContent = STR.tbd; priceEl.className = 'pdp__price-tbd'; }
      }
      var max = applyInventory(v);
      setStock(v, max);
      var qtyWrap = section.querySelector('.pdp__qty');
      if (qtyWrap) {
        qtyWrap.classList.toggle('is-disabled', !v.available);
        qtyWrap.querySelectorAll('button, input').forEach(function (el) { el.disabled = !v.available; });
      }
      if (addBtn && addText) {
        addBtn.disabled = !v.available;
        addText.textContent = v.available ? STR.add : STR.soldout;
      }
      if (gallery && v.featured_media) showMedia(gallery, String(v.featured_media.id));
    }
    updateSwatchStates();
    if (picker) {
      picker.querySelectorAll('input[data-option-input]').forEach(function (i) {
        i.addEventListener('change', updateVariant);
      });
    }

    var form = section.querySelector('#product-form');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtn && addBtn.disabled) return;
        setAddError('');
        if (addText) addText.textContent = STR.adding;
        fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
          .then(function (r) { if (!r.ok) return r.json().then(function (er) { throw er; }); return r.json(); })
          .then(function () { return refreshCart(); })
          .then(function () {
            if (addBtn) addBtn.classList.add('is-added');
            if (addText) addText.textContent = STR.added;
            openCart();
            setTimeout(function () {
              if (addBtn) addBtn.classList.remove('is-added');
              if (addText) addText.textContent = STR.add;
            }, 1600);
          })
          .catch(function (err) {
            if (addText) addText.textContent = STR.add;
            /* 422 = Shopify rechazo el add porque ya no hay inventario suficiente. */
            if (err && err.status === 422) {
              setAddError(err.description || STR.errStock);
              if (addBtn) addBtn.disabled = true;
              if (addText) addText.textContent = STR.soldout;
            } else {
              setAddError(STR.err);
            }
          });
      });
    }
  }

  /* ---------- Scroll reveal (subtle entrance on titles + cards) ----------
     Animates opacity/transform only. No-JS keeps everything visible (class is
     only added when JS + IntersectionObserver + motion are all available). */
  (function () {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.documentElement.classList.add('js-reveal');
    var targets = Array.prototype.slice.call(
      document.querySelectorAll('.section-head, .cat-card, .product-card')
    );
    targets.forEach(function (el, i) {
      el.classList.add('reveal');
      var d = (i % 4) * 70;           // gentle stagger across a row
      if (d) el.style.transitionDelay = d + 'ms';
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    targets.forEach(function (el) { io.observe(el); });
  })();
})();
